import React from "react";
import "./LessonDetails.css";
import { GiWaveSurfer } from "react-icons/gi";

export const LessonDetails = ({ lesson }) => {
  return (
    <div className="lesson-detail">
      <h2 className="lesson-detail__title">| {lesson.title.toUpperCase()}</h2>
      <p className="lesson-detail__objective">{lesson.objective}</p>
      <div className="lesson-detail__info">
        {lesson.pointsToLearn.map((item, i) => (
          <div key={i} className="info-box">
            <GiWaveSurfer size={26} color="#65839d" />
            <p marginLeft="10px">{item}</p>
          </div>
        ))}
      </div>
      <p className="lesson-detail__quote">{lesson.quote}</p>
    </div>
  );
};
